import { paletteTheme } from "@configs/theme/custom/palette";

export const menuTheme = {
  itemPaddingInline: 16,
  itemSelectedBg: paletteTheme.colorPrimaryBackground,
  subMenuItemBg: "#ffffff",
  iconMarginInlineEnd: 8,
};
